"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Validates if a value is not null (!== undefined, !== null).
 *
 * @export
 * @class IsNotNullValidator
 * @implements {PropertyValidator<any>}
 */
class IsNotNullValidator {
    isValid(input) {
        return input !== null && typeof input !== "undefined";
    }
}
exports.IsNotNullValidator = IsNotNullValidator;
//# sourceMappingURL=IsNotNullValidator.js.map